export default __webpack_public_path__ + "static/media/game_results_banner.83d6e763.png";